"use client"

import { Skeleton } from "@rarible_int/anaconda_ui_components"

interface DetailItem {
  title: React.ReactNode
  description: React.ReactNode
}

interface Props {
  detailsData: DetailItem[]
}

function DetailsItem(props: DetailItem) {
  return (
    <div className="flex min-w-0 items-center justify-between gap-2">
      <span className="shrink-0 text-nowrap text-foreground/60">
        {props.title}
      </span>
      <span className="min-w-0 max-w-full truncate text-right">
        {props.description}
      </span>
    </div>
  )
}

function ItemDetailsContent({ detailsData }: Props) {
  return (
    <div className="flex flex-col gap-1">
      {detailsData.map((item, idx) => (
        <DetailsItem
          key={idx}
          title={item.title}
          description={item.description}
        />
      ))}
    </div>
  )
}

export function ItemDetailsSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="flex flex-col gap-1">
      {[...Array(count)].map((_, idx) => (
        <div
          key={idx}
          className="flex flex-wrap items-center justify-between gap-[2px]"
        >
          <Skeleton className="h-6 w-[100px]" />
          <Skeleton className="h-6 w-[200px]" />
        </div>
      ))}
    </div>
  )
}

export function ItemDetailsView(props: Props) {
  return <ItemDetailsContent {...props} />
}
